export function setVuexKeys<T>(vuexMethods: T): T {
    let props = Object.getOwnPropertyNames(vuexMethods);
    if (props) {
        props.forEach(elementName => {
            vuexMethods[elementName]._vuexKey = elementName;
        });
    }
    return vuexMethods;
}
